import React from "react";
import { Text, Em } from "@radix-ui/themes";
import { ConnectingToAgentMessage } from "../../entities/Message";

export function ConnectingToAgentMessageComponent({
  text,
}: ConnectingToAgentMessage) {
  return (
    <Text
      size={"2"}
      color={"gray"}
      style={{
        padding: "2px 8px",
      }}
    >
      <Em>{text}</Em>
    </Text>
  );
}
